import Modal from 'react-modal';
import {useState} from 'react'
import {motion} from 'motion/react'
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";

import { IoClose } from "react-icons/io5";
import Alfredo from '../../assets/imagens/Alfredo.png'

import Button from '../ui/Button';
import FormatTimer from '../ui/FormatTimer';
import FormatDate from '../ui/FormatDate';

import { API_URL } from '../../config/api';

import './Modais.css'
import { useAuth } from '../../context/AuthContext';
export default function ModalIniciarChamado ({modalIsOpen, closeModal, ticket}){
    const navigate = useNavigate()
    const token = localStorage.getItem("token")
    const [noComputador, setNoComputador] = useState(false)

    const {logout} = useAuth()

    const handleIniciar = async () => {
        console.log(ticket.userTicketId)

        try {
            const response = await fetch(`${API_URL}/user/startTicket`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`

                },
                body: JSON.stringify({
                userTicketId: ticket.userTicketId
            })
            });

            if (response.status === 403) {
                    logout()
                    return
            }

            if (!response.ok) {
                const erro = await response.text();
                console.log("Erro do backend:", erro);
                throw new Error(`Erro HTTP: ${response.status}`);
            }

            const data = await response.text();
            console.log("Chamado iniciado:", data);
            console.log("Ticket:", ticket)

            navigate("/chamado", {
                state: { ticket }
            });

        } catch (error) {
            console.log("Não foi possível iniciar o chamado:", error);
        }
    };

    const handleEncerrarChamado = async () => {
         try {
            const response = await fetch(`${API_URL}/user/timeout/${ticket.userTicketId}`, {
                method: "PUT",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });

             if (response.status === 403) {
                    logout()
                    return
                }

            if (!response.ok) {
                const erro = await response.text();
                console.log("Erro do backend:", erro);
                throw new Error(`Erro HTTP: ${response.status}`);
            }

            const data = await response.text();
            closeModal()
            navigate(0)
        } catch (error) {
            console.log("Não foi possível  o chamado:", error);
        }
    };

    return(
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            className='ModalIniciar'
            overlayClassName="overlayModal"
            >
            <div className='containerModalIniciar'>
                {!ticket.startTime &&
                    <motion.button
                        whileHover={{
                            rotate: [0, 180],
                            scale:[1.0, 1.1],
                            transition: {
                                duration: 0.3,
                                times: [0, 1],
                                ease: ["easeInOut", "easeOut"],
                            },
                        }}

                        onClick={closeModal}
                        className="fechar"
                    >

                        <IoClose size={40} color={'var(--vermelho)'} />

                    </motion.button>
                }

                    <div className='flex'>
                        <img className='avatarAlfredo' width={200} src={Alfredo} />

                        {/* Caso 1: Usuário já inicou o chamado */}
                        {ticket.startTime ? 
                        
                        <div className='areaTexto'>
                            <h1>OPS, Parece que você já iniciou esse chamado!</h1>
                            <div>
                                <p>Chamado iniciado às: </p>
                                <FormatDate date={ticket.startTime} />
                                
                            </div>
                            

                            <div className='regras'>
                                <p>Não será possível refazer esse chamado.</p>
                            </div>

                            <Button 
                                className="btn btnVermelho"
                                onClick={()=>handleEncerrarChamado()}
                                text="Voltar" />
                        </div> 
                        
                        :
                        
                        //Caso 2: Usuário não inicou o chamado
                        <div className='areaTexto'>
                            <h1>Pronto para assumir o chamado?</h1>
                            <div>
                                <p>Você tem </p>
                                <FormatTimer sla={ticket.sla} />
                            </div>

                            <div className='regras'>
                                <p> 
                                    Lembre-se!
                                </p>
                                <ul>
                                    <li>
                                        <p>Depois de iniciar, não será possível pausar ou refazer o chamado;</p>
                                    </li>
                                    <li>
                                        <p>Quanto mais rápido você concluir o chamado, mais XP você ganhará</p>
                                    </li>
                                </ul>
                            </div>

                            {ticket.image ? (
                                    <>
                                        <div className="radio">
                                            <p>Este chamado possui interação com imagem e deve ser acessado pelo computador.</p>
                                            <input
                                                type="checkbox"
                                                id="optionId"
                                                checked={noComputador}
                                                onChange={(e) => setNoComputador(e.target.checked)}
                                            />

                                            <label htmlFor="optionId">
                                                Confirmo que estou no computador
                                            </label>
                                        </div>

                                        {!noComputador ? <Button
                                            className="btnDisabled"
                                            onClick={()=>{}}
                                            text="Iniciar"
                                        /> :
                                        <Button
                                            className="btnAmarelo" 
                                            onClick={handleIniciar}
                                            text="Iniciar"
                                            disabled={!noComputador}
                                        /> }
                                    </>
                                )
                                    :
                                
                                     <Button
                                            className=" btnAmarelo"
                                            onClick={handleIniciar}
                                            text="Iniciar"
                                        />
                                }



                        </div>}
                    </div>
            </div>
        </Modal>
    )
    
}